<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="'item-' + index"
      tabindex="-1"
      name="dropdown-item"
      class="group peer flex cursor-pointer justify-between px-4 py-3 text-base font-normal text-gray-darkest md:m-0 md:items-center md:justify-between md:!border-0 md:text-[15px] md:hover:bg-primary/10 lg:flex lg:justify-between [&_+_.peer]:border-t [&_+_.peer]:border-gray"
      :class="{
        active: activeOptionId && activeOptionId == option.id,
        'is-instock': option.inStock,
        lowstock: option.inStock && option.stockData < LOW_STOCK_THRESHOLD,
        'pointer-events-none': !option.inStock
      }"
      @click="$emit('click', option)"
    >
      <DropdownOptionItem
        :class-names="'opacity-30 group-[&.active]:font-bold group-[&.is-instock]:opacity-100'"
        :is-in-stock="option.inStock"
        :option="option"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

import { LOW_STOCK_THRESHOLD } from '@/shared/constants/product';

import DropdownOptionItem from './DropdownOptionItem.vue';

defineEmits(['click']);

defineProps({
  options: {
    type: Array,
    required: true
  },
  activeOptionId: {
    type: Number,
    default: null
  }
});

onMounted(() =>
  document.querySelector('[name="dropdown-item"].active')?.focus()
);
</script>
